module.exports = __webpack_public_path__ + "img/new-q@2x.316a02a3.png";